import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';
import TouchableElement from '@components/common/touchableElement';
import { SmallLoading } from '@components/loading';
import { WIZARD_STEPS, isSimpleType as isSimpleTypeFn } from '@components/common/NCFileType/NCFileWizardNoERP/constants';
import { WizardHeaderProps, TouchableRenderProps } from '@components/common/NCFileType/NCFileWizardNoERP/types';

const WizardHeader: React.FC<WizardHeaderProps> = ({
  currentStep,
  selectedType,
  ncFileName,
  loading,
  canSkip,
  onBack,
  onNext,
  onSkip,
  C,
  scale,
  font,
}) => {
  const isSimpleType = isSimpleTypeFn(selectedType);

  const getRightButtonLabel = (): string => {
    if (currentStep === 4) {
      return isSimpleType ? 'Save' : 'Save & Link';
    }
    return 'Next';
  };

  const getBackLabel = (): string => {
    if (currentStep === 1) return 'Cancel';
    return 'Back';
  };

  const title = WIZARD_STEPS.find((s) => s.step === currentStep)?.title || 'Configure NC File';

  return (
    <View
      style={{
        width: '100%',
        height: scale(54),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: scale(12),
      }}
    >
      <View style={{ width: scale(100), alignItems: 'flex-start' }}>
        <TouchableElement onPress={onBack}>
          {({ boxStyle, pressHoverColor }: TouchableRenderProps) => (
            <View style={[boxStyle, { padding: scale(8) }]}>
              <Text numberOfLines={1} style={[font.Body, { color: C(pressHoverColor('System/Light/Blue')) }]}>{i18n.t(getBackLabel())}</Text>
            </View>
          )}
        </TouchableElement>
      </View>

      <View style={{ flex: 1, alignItems: 'center', minWidth: 0 }}>
        <Text numberOfLines={1} style={[font['Headline'], { color: C('Label/Light/Primary'), textAlign: 'center', width: '100%' }]}>
          {i18n.t(title)}
        </Text>
        <Text numberOfLines={1} style={[font['Caption 1'], { color: C('Label/Light/Secondary'), textAlign: 'center', width: '100%' }]}>
          {ncFileName}
        </Text>
      </View>

      <View style={{ width: scale(100), flexDirection: 'row', justifyContent: 'flex-end', gap: scale(8) }}>
        {canSkip && (
          <TouchableElement onPress={onSkip}>
            {({ boxStyle, pressHoverColor }: TouchableRenderProps) => (
              <View style={[boxStyle, { padding: scale(8) }]}>
                <Text numberOfLines={1} style={[font.Body, { color: C(pressHoverColor('Label/Light/Tertiary')) }]}>{i18n.t('Skip')}</Text>
              </View>
            )}
          </TouchableElement>
        )}
        <TouchableElement onPress={loading ? undefined : onNext}>
          {({ boxStyle, pressHoverColor }: TouchableRenderProps) => (
            <View style={[boxStyle, { padding: scale(8) }]}>
              {loading ? (
                <SmallLoading />
              ) : (
                <Text numberOfLines={1} style={[font.Headline, { color: C(pressHoverColor('Link/Light/Primary')) }]}>{i18n.t(getRightButtonLabel())}</Text>
              )}
            </View>
          )}
        </TouchableElement>
      </View>
    </View>
  );
};

export default WizardHeader;
